<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { t, tm } = useI18n();

const instructionBlocks = computed(() => tm("faq.activators") as unknown);
</script>

<template>
  <AccordionComponent>
    <template #title>
      {{ t("calculators.activations.faq.activators.title") }}
    </template>
    <template #faq-content>
      <template v-for="(block, index) in instructionBlocks" :key="index">
        <h4 class="list-title">{{ block.title }}</h4>
        <ul class="list-context">
          <li v-for="(item, i) in block.items" :key="i">
            {{ item }}
          </li>
        </ul>
        <div
          v-if="index < instructionBlocks.length - 1"
          class="w-full h-px bg-ternary my-8"
        ></div>
      </template>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.activations.faq.activators.collapse_btn") }}
    </template>
  </AccordionComponent>
</template>

<style scoped>
.list-title {
  @apply text-2xl font-semibold leading-[32px] mb-[20px];
}
.list-context {
  @apply list-disc pl-6 space-y-2 text-xl font-normal leading-[28px];
}
</style>
